module.exports = __webpack_public_path__ + "static/media/Fondo2.a95835bd.jpg";